import styled from 'styled-components';

export const StyledConfirmedAppointmentsCardCount = styled.div`
   font-size: 48px;
   line-height: 28px;
`;
StyledConfirmedAppointmentsCardCount.displayName = 'StyledConfirmedAppointmentsCardCount';
